module.exports = __webpack_public_path__ + "media/brands/digicross-730071a3.png";